import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Paper, Grid, Typography } from '@material-ui/core';

import useStyles from './styles';

import ServicioDisponible from './ServicioDisponible';
import Loading from './Skeleton';

import { getRangoHorarios } from '../../helpers/getRangoHorario';

const SelectorServicio = ({ servicios, servicioSelected, selectedServicioRedux }) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.auth);
  const { linea } = useSelector((state) => state.servicios.busqueda);

  const [servicioSeleccionado, setServicioSeleccionado] = useState(servicioSelected);
  const [mensajeRango, setMensajeRango] = useState();

  useEffect(() => {
    if (servicioSeleccionado) dispatch(selectedServicioRedux(servicioSeleccionado));
  }, [servicioSeleccionado]); // eslint-disable-line react-hooks/exhaustive-deps

  const armarMensaje = (response) => {
    let idR = 0;

    const text = response.map((mr) => (
      <>
        {idR != mr.ramal.id ? (
          <tr>
            <td style={{ textAlign: 'left' }}>
              Ramal <b> {mr.ramal.nombre} </b> :
            </td>
          </tr>
        ) : (
          ''
        )}
        <tr>
          <td>
            sentido <b> {mr.sentido.nombre} </b> de {mr.desde.substr(0, 5)} a
            {mr.hasta.substr(0, 5)}
          </td>
        </tr>
        <tr>
          <td style={{ display: 'none' }}>{(idR = mr.ramal.id)} </td>
        </tr>
      </>
    ));

    return (
      <table style={{ maxWidth: '500px', margin: 'auto' }}>
        <tr>
          <td style={{ textAlign: 'left' }}>
            Para la línea <b>{response[0].linea.nombre}</b>, podes reservar de Lunes a
            Viernes en estos horarios:
          </td>
        </tr>
        {text}
      </table>
    );
  };

  useEffect(() => {
    if (servicios !== null ?? !servicios.length) {
      const getRangos = async () => {
        const response = await getRangoHorarios(token);
        setMensajeRango(armarMensaje(response.data));
      };
      getRangos();
    }
  }, [servicios]); // eslint-disable-line react-hooks/exhaustive-deps

  function addClaseSelected(itemId) {
    if (servicioSeleccionado) {
      return servicioSeleccionado.servicio.id === itemId
        ? classes.servicioSeleccionado
        : '';
    } else {
      return '';
    }
  }

  const view = (
    <Fragment>
      {/* <Grid item xs={12}>
        <PasajerosAcompaniantes />
      </Grid> */}
      <Grid item xs={12}>
        <br />
      </Grid>
      {servicios !== null ? (
        servicios.map((obj) => (
          <Grid item xs={12} md={4} lg={4} key={obj.id} htmlFor='servicio-seleccionado'>
            <Paper spacing={1} className={addClaseSelected(obj.servicio.id)}>
              <ServicioDisponible
                key={obj.servicio.id}
                item={obj}
                servicioSeleccionado={servicioSeleccionado}
                setServicioSeleccionado={setServicioSeleccionado}
              ></ServicioDisponible>
            </Paper>
          </Grid>
        ))
      ) : (
        <Loading />
      )}
    </Fragment>
  );

  const sinServicios = (
    <Grid item xs={12}>
      <Paper elevation={0} className={classes.vacio}>
        <Typography>
          <b>Lo sentimos, las reservas se encuentran agotadas</b>
          <br />
          <br />
          {mensajeRango}
        </Typography>
      </Paper>
    </Grid>
  );

  return <>{servicios !== null ? servicios.length ? view : sinServicios : <Loading />}</>;
};

export default SelectorServicio;
